import { render, staticRenderFns } from "./WasteWaterTreatmentPump.vue?vue&type=template&id=5fc0f8ba&"
import script from "./WasteWaterTreatmentPump.vue?vue&type=script&lang=js&"
export * from "./WasteWaterTreatmentPump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports